import React from "react";
import Hero from "../Components/Hero/Hero";

const Home = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};

export default Home;
